module.exports = __webpack_public_path__ + "static/dioxane.1a46aa8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dioxane.jpg
// module id = 436
// module chunks = 35783957827783